import { AuxiliumComponent } from "../auxilium-component";

export default class Tree extends AuxiliumComponent {
	static observable = ["description"];

	constructor() {
		super();

		this.description ??= "Tree view";
	}

	parsedCallback() {
		this.classList.add("tree__wrapper");

		const list = document.createElementWithContents("ul", null, {
			className: "tree",
			role: this.closest("chip-treeitem") ? "group" : "tree",
			ariaLabel: this.description
		});

		if (this.identifier) {
			list.id = this.identifier;
		}

		for (const item of [...this.children ?? []].filter(x => x.nodeName === "CHIP-TREEITEM")) {
			this.AddItem(item, list);
		}

		this.appendChild(list);
	}

	AddItem(item, list) {
		list ??= this.querySelector(":scope > ul");

		if (list) {
			const listItem = document.createElementWithContents("li", item, {
				className: "tree-item",
				role: "treeitem",
				ariaExpanded: item.open.toString(),
				tabIndex: 0
			}), itemID = item.getAttribute("identifier") ?? "";

			if (itemID) {
				listItem.id = itemID;
			}

			list.appendChild(listItem);
		} else {
			this.appendChild(item);
		}
	}
}
